module.exports = __webpack_public_path__ + "static/media/EY.cbc22b6d.png";